// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__BgJuG","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2lI6l"};